import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { ICONS } from 'Components/utils/icon/icons';
import { LAYER_NAME_UPSELL_RENTALS } from 'Components/utils/layers/layers.constants';
import { useResponsive } from 'Components/utils/responsive/ResponsiveContext';
import { useLayer } from 'Src/hooks/use-layer/useLayer';
import { t } from 'Src/i18n';
import { TRACK_EVENT_NAMES } from 'Tracking/constants';
import { useTrackEvent } from 'Tracking/tracking-api/useTrackEvent';
import { Badge } from 'Components/frameworks/badge/Badge';
import DynamicLink from 'Components/frameworks/dynamic-link/DynamicLink';
import { Scrollable } from 'Components/frameworks/scrollable/Scrollable';
import { Text } from 'Components/frameworks/text/Text';
import { Title } from 'Components/frameworks/title/Title';
type Props = {
  className?: string;
  hasRentals?: boolean;
};
export const SkiPackageReassurance = ({ className, hasRentals = false }: Props) => {
  const { isTablet } = useResponsive();
  const { nextUri } = useLayer(LAYER_NAME_UPSELL_RENTALS);
  const { trackClickEvent } = useTrackEvent();
  const items = [
    {
      title: t('booking.activities.skiPackage.skiPass'),
      text: t('booking.activities.skiPackage.skiPassDescription'),
    },
    {
      title: t('booking.activities.skiPackage.groupLessons'),
      text: t('booking.activities.skiPackage.groupLessonsDescription'),
    },
  ];
  return isTablet ? (
    <div className={classnames('overflow-hidden rounded-12 bg-white p-20 shadow', className)}>
      <Title className="mb-10" hLevel={3} theme="title-brand-n3">
        {t('booking.activities.skiPackage.title')}
      </Title>
      {items.map(({ text, title }, i) => (
        <div
          className={classnames('py-15', {
            'border-b-1 border-dashed': hasRentals || i !== items.length - 1,
          })}
          key={title}
        >
          <Title className="mb-5 !items-center" theme="title-sans-n2">
            <Badge className="size-28" iconName={ICONS.SKI} variant="pill" />
            {title}
            <span className="ms-auto font-brand text-12 text-green">{t('common.included')}</span>
          </Title>
          <Text text={text} theme="text-sans-n1" />
        </div>
      ))}
      {hasRentals && (
        <DynamicLink
          className="block text-center"
          onClick={() =>
            trackClickEvent(TRACK_EVENT_NAMES.CLICK_ACTIVITIES, {
              detail_click: 'right_sidebar',
            })
          }
          shallow
          url={nextUri}
        >
          <Badge
            className="mt-15 size-30 border-grey bg-white text-grey"
            iconName={ICONS.SKI_EQUIPMENTS}
            variant="pill"
          />
          <Text
            className="mb-5"
            text={t('booking.activities.skiEquipment.description')}
            theme="text-sans-n1"
          />
          <p className="text-14 text-black underline">
            {t('booking.activities.skiEquipment.chooseCTA')}
          </p>
        </DynamicLink>
      )}
    </div>
  ) : (
    <Scrollable className={classnames('-mx-20', className)}>
      <div className="flex p-10">
        {items.map(({ text, title }) => (
          <div
            className="last:scroll-x-ghost-m-20 last:scroll-x-ghost-m mx-10 w-[calc(100vw-60px)] flex-none rounded-12 bg-white p-10 shadow"
            key={title}
          >
            <Title className="mb-5 !items-center" theme="title-sans-n2">
              <Badge className="size-28" iconName={ICONS.SKI} variant="pill" />
              {title}
              <span className="ms-auto font-brand text-12 text-green">{t('common.included')}</span>
            </Title>
            <Text text={text} theme="text-sans-n1" />
          </div>
        ))}
      </div>
    </Scrollable>
  );
};
